<mat-form-field>
  <mat-label>
    {{ ("poolerTypes" | i18n) || "Poolertypen" | titlecase }}
  </mat-label>
  <mat-select
    multiple
    [value]="selectedPoolerTypeIds$ | async"
    (selectionChange)="onSelectionChange($event.value)"
    name="poolerTypeMultiSelect"
    [disabled]="disabled$ | async"
    data-cy="pooler-type-multi-select">
    <mat-option
      *ngFor="let poolerType of customerPoolerTypes$ | async"
      [value]="poolerType.id"
      [attr.data-cy]="'pooler-type-option-' + poolerType.id">
      {{ poolerType.displayName }}
    </mat-option>
  </mat-select>
  <mat-hint
    align="end"
    *ngIf="hintContent$ | async as hintContent">
    <ng-container *ngTemplateOutlet="hintContent"></ng-container>
  </mat-hint>
</mat-form-field>
